// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "ul.selos[data-v-a69025de] {\n  position: absolute;\n  bottom: 1em;\n  right: 0;\n  list-style: none;\n  width: 50%;\n}\nul.selos li[data-v-a69025de] {\n  width: 100%;\n  height: 75px;\n}\nul.selos li img[data-v-a69025de] {\n  object-fit: contain;\n  object-position: right;\n  visibility: visible;\n  box-shadow: 0 0 10px -2px black;\n  max-height: 100%;\n  height: auto;\n}\n", ""]);
// Exports
module.exports = exports;
